"use client";

import type { PackageSummary } from "../pricing";
import { ManageYesNoStep } from "./ManageYesNoStep";

/**
 * Audit side: outstanding audited financial statements for past years. The
 * third of these past-years questions, after the company-secretary and
 * accounting ones — no explainer panel on this one either.
 */
export function ManageAuditReturnsStep({
  value,
  onChange,
  summary,
  onNext,
}: {
  value: string | null;
  onChange: (value: string) => void;
  summary: PackageSummary;
  onNext: () => void;
}) {
  return (
    <ManageYesNoStep
      heading="Need help with audited financial statements from previous years?"
      intro="As your new auditor, we can assist with filing outstanding audited financial statements to ensure compliance."
      name="past-audit-statements"
      value={value}
      onChange={onChange}
      summary={summary}
      onNext={onNext}
    />
  );
}
